import { useState, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import DataTable from "../../components/DeveloperComponents";
import { NotificationContext } from "../../contexts/NotificationContexts";
import { requestChatIds, requestFetchTaggedChats } from "../../requests/chat_requests";
import { TicketSearchComponent } from "../../components/SearchComponents";
import { PageHeader } from "../../components/HeaderComponents";
import { useTranslation } from "react-i18next";
import { BreadCrumbsGeneral } from "../../components/NavigationComponents";
import { AccountContext } from "../../contexts/AccountContexts";


export function TicketMain() {
    const { t } = useTranslation('edit')
    const { user } = useContext(AccountContext)
    const { isSidebar, setIsSidebar, chatTickets } = useContext(NotificationContext)

    const [tickets, setTickets] = useState([]);
    const [membersData, setMembersData] = useState({})
    const [activeChatIds, setActiveChatIds] = useState([])

    const [currentPage, setCurrentPage] = useState(1)
    const [sortConfig, setSortConfig] = useState({ key: null, direction: "desc" });
    const [entriesPerPage, setEntriesPerPage] = useState(localStorage.getItem(user.id + "_perPage") ? parseInt(localStorage.getItem(user.id + "_perPage")) : 10);
    const [totalPages, setTotalPages] = useState(0)
    const [totalCount, setTotalCount] = useState(0)
    const [isDefault, setIsDefault] = useState(true)
    const [fetchTaggedChats, setFetchTaggedChats] = useState([])
    const [filterTaggedChats, setFilterTaggedChats] = useState(false)

    const navigator = useNavigate();

    useEffect(() => {

        if (isSidebar) {
            setIsSidebar(false)
        }

    }, []);

    useEffect(() => {
        requestChatIds({})
            .then((data) => {
                setActiveChatIds(data.active_chat_ids)
            })
            .catch((error) => {
                console.error(error.status, error.message)
            })

    }, [chatTickets])

    // useEffect(() => {
    //     requestFetchTaggedChats({ userId: user.id }).then((data) => {
    //         setFetchTaggedChats(data.tickets);
    //     });
    // }, [currentPage, entriesPerPage]);

    const handleSearchTicket = (tickets, users) => {
        setTickets((prev) => [...tickets])
        setMembersData((prev) => ({...users}))
    }

    const breadCrumbs = [
        {
            link: "/admin/dashboard",
            name: t("Home")
        },
        {
            link: null,
            name: t("Tickets")
        }
    ]

    return (
        <div className="flex flex-col justify-start items-center w-full py-2 gap-5 pb-10 px-4 h-full">
            <PageHeader pageTitle={t("Tickets")} />

            <div className="w-full">
                <h1 className="text-xl font-semibold">{t('Manage Tickets')}</h1>
                <BreadCrumbsGeneral elements={breadCrumbs} />
            </div>

            <TicketSearchComponent getData={handleSearchTicket} 
            currentPage={currentPage} setCurrentPage={setCurrentPage} entriesPerPage={entriesPerPage} setEntriesPerPage={setEntriesPerPage} 
            isDefault={isDefault} setIsDefault={setIsDefault} sortConfig={sortConfig} setSortConfig={setSortConfig} setTotalPages={setTotalPages} 
            setTotalCount={setTotalCount} 
            fetchTaggedChats={fetchTaggedChats} setFetchTaggedChats={setFetchTaggedChats}
            filterTaggedChats={filterTaggedChats} setFilterTaggedChats={setFilterTaggedChats}
            />

            <main className="flex flex-col items-center w-full mx-auto  bg-white dark:bg-gray-700 rounded-xl shadow-sm p- gap-4 h-full">
                <DataTable
                    data={tickets}
                    setData={setTickets}
                    members={membersData}
                    activeChatIds={activeChatIds}
                    sortConfig={sortConfig}
                    setSortConfig={setSortConfig}
                    entriesPerPage={entriesPerPage}
                    setEntriesPerPage={setEntriesPerPage}
                    currentPage={currentPage}
                    setCurrentPage={setCurrentPage}
                    totalPages={totalPages}
                    setTotalPages={setTotalPages}
                    totalCount={totalCount}
                    fetchTaggedChats={fetchTaggedChats}
                    setFetchTaggedChats={setFetchTaggedChats}
                    filterTaggedChats={filterTaggedChats}
                    setFilterTaggedChats={setFilterTaggedChats}
                />
            </main>

        </div>
    )

}



export default TicketMain;